// extracted by mini-css-extract-plugin
export var errorsContainer = "_r4-1";
export var link = "_r4-0";